import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class PowerBiService {
  API_URL: string = "https://api.powerbi.com/v1.0/myorg/datasets/";
  constructor(private http: HttpClient) {}

  refreshBBDD(datasetId, bearerToken): any {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    });
    return this.http.post(
      `${this.API_URL}${datasetId}/refreshes`,
      {},
      { headers }
    );
  }


  getTokenFrom(tenantID): any {

    const body = new URLSearchParams();
    body.set('grant_type', 'client_credentials');
    body.set('client_id', '');
    body.set('client_secret', '');
    body.set('scope', 'https://analysis.windows.net/powerbi/api/.default');


    const headers = new HttpHeaders({
      "Content-Type": 'application/x-www-form-urlencoded',
    });
    return this.http.post(
      `https://login.microsoftonline.com/${tenantID}/oauth2/v2.0/token`,
      {body},
      { headers }
    );
  }
}
